<template>
    <div >
        <v-card elevation="0" style="width: 100% !important">
            <v-card-text elevation="0" class="pa-4">
                <v-data-table
                    :headers="headers"
                    :items="tenantGroups"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    fab
                                    @click="openEdit(item)"
                                    x-small
                                    color="orange"
                                    text
                                >
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    text
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenGroupsSummary = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog max-width="500" v-model="tenantGroupForm">
            <v-card max-width="500">
                <v-card-title>
                    <v-icon large left> mdi-lock-plus </v-icon>
                    <h1 class=" font-weight-light primary--text text-h5 mt-n1">Añadir Tenant a un Grupo</h1>
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="12" class="px-1">
                            <v-card elevation="0">
                                <v-row class="my-1 mx-1">
                                    <h4
                                        class="font-weight-light primary--text px-2"
                                    >
                                        Tenant
                                    </h4>
                                </v-row>
                                <!-- <v-divider class="mx-1"></v-divider> -->
                                <v-row no-gutters>
                                    <v-text-field
                                        disabled
                                        class="pa-4"
                                        :label="tenantForm.name"
                                    ></v-text-field>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="12" class="px-1">
                            <v-card elevation="0">
                                <v-row class="my-1 mx-1">
                                    <h4
                                        class="font-weight-light primary--text px-2"
                                    >
                                        Groups
                                    </h4>
                                </v-row>
                                <!-- <v-divider class="mx-1"></v-divider> -->
                                <v-row no-gutters>
                                    <v-select
                                        class="pa-4"
                                        :items="groups"
                                        v-model="tenantForm.groups"
                                        multiple
                                        chips
                                        hint="Recuerde añadir todos los grupos a los que desea que pertenezca"
                                        persistent-hint
                                        item-text="name"
                                        return-object
                                        clearable
                                    ></v-select>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn
                        color="success"
                        depressed
                        @click="editTenantGroups"
                    >
                        Añadir
                    </v-btn>
                    <v-btn
                        text
                        color="red"
                        @click="tenantGroupForm = false"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';

export default {
    data: () => ({
        tenantGroupForm: false,
        search: '',
        headers: [
            {
                text: 'Tenant',
                value: 'tenant.name',
                align: 'start',
            },
            {
                text: 'Group',
                value: 'groups',
                align: 'start',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    computed: {
        tenantGroups(){
            let items = [];

            this.tenants.forEach(tenant => {
                items.push({
                    tenant: tenant,
                    groups: tenant.groups.map(group => group.name).join(', '),
                });
            });

            return items;
        },
        tenantForm: {
            get() {
                return this.$store.state.tenantManagement.newTenant.form;
            },
            set(val) {
                this.$store.commit('tenantManagement/newTenant', val);
            },
        },
        ...mapState('tenantManagement', {
            isLoadingTenants: (state) => state.isLoadingTenants,
            tenants: (state) => state.tenants,
        }),
        ...mapState('databaseManagement/auth', {
            groups: (state) => state.groups.groups,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    methods: {
        editTenantGroups() {
            this.tenantForm.group_id = this.tenantForm.groups.map(group => group.id);
            this.$store.dispatch('tenantManagement/editTenant');
            this.tenantGroupForm = false;
        },
        openEdit(item) {
            this.tenantGroupForm = true;
            this.tenantForm = item.tenant;
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'GROUPS',
                isOpenDeleteDialog: true,
            };
            console.log(deleteObj);

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('databaseManagement/auth', ['getGroups']),
    },
    watch: {},
};
</script>

<style>
</style>







